var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"PlanSelector\" ng-show=\"!selectedTrial\">\n<div ng-repeat=\"plan in plans\" ng-click=\"onselected(plan)\" class=\"PlanSelector-planBadge\">\n<div class=\"PlanSelector-planBadge-radio\" ng-class=\"{true: 'PlanSelector-planBadge-selected', false: 'PlanSelector-planBadge-unselected'}[isSelected(plan.interval)]\"></div>\n<span class=\"PlanSelector-planBadgeAmount\">{{ plan.amount / 100 | currency:\"$\" }} {{ 'COMPONENT.PLAN_SELECTOR.PER_' + plan.interval | uppercase | translate }}\n</span>\n<span class=\"PlanSelector-planBadgeInterval\">{{ 'COMPONENT.PLAN_SELECTOR.' + plan.interval + 'ly' | uppercase | translate }}</span>\n</div>\n</div>\n";
var id1="plan.selector.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/plan/plan.selector.html
// module id = 505
// module chunks = 0